<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <app-empty-check-in-toolbar [number]="this.number" [isReadOnly]="isReadOnly"
            [isSubmitting]="isSubmitting" [isLoading]="isLoading" (cancelClick)="cancel()" (save)="onSaveClick($event)"
            (shuntMoveClick)="addShuntMove()" [action]="this.emptyCheckIn.actions">
        </app-empty-check-in-toolbar>
    </div>
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'empty-check-in-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" height="80vh">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
                            <span>Details</span>
                            <span class="text-muted fs-5">
                                @if (this.number) {
                                    ID: {{ this.emptyCheckIn.numberWithPrefix }}
                                }
                            </span>
                        </div>
                        <div class="card-body">
                            @if (this.number) {
                                <div class="row mb-3">
                                    <div class="col-6">
                                        <div>
                                            <strong class="me-2">Status: </strong>
                                            <span class="badge" [ngClass]="getBadgeClass(this.emptyCheckIn.status)">
                                                {{ this.emptyCheckIn.status | emptyCheckInStatus }}
                                            </span>
                                        </div>
                                        @if (emptyCheckIn.currentLocationText) {
                                            <div class="mt-1">
                                                <strong class="me-2">Current Location: </strong>
                                                <span>{{ emptyCheckIn.currentLocationText }}</span>
                                            </div>
                                        }
                                    </div>
                                    <div class="col-6">
                                        @if (this.emptyCheckIn.appointmentNumber) {
                                            <div>
                                                <strong class="me-2">Inbound Appointment: </strong>
                                                <a [routerLink]="`/inbound/appointments/details/${this.emptyCheckIn.appointmentNumber}`"
                                                    class="text-decoration-none">{{ this.emptyCheckIn.appointmentNumber }}</a>
                                            </div>
                                        }
                                        @if(this.emptyCheckIn.emptyCheckOutNumber) {
                                            <div>
                                                <strong class="me-2">Outbound: </strong>
                                                <a [routerLink]="`/outbound/empty-check-outs/details/${this.emptyCheckIn.emptyCheckOutNumber}`"
                                                    class="text-decoration-none">{{ this.emptyCheckIn.emptyCheckOutNumber }}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Carrier: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="emptyCheckIn.carrierId" [dataSource]="carrierDataSource"
                                        displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                        stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Carrier is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Warehouse:</label>
                                    <dx-select-box value="HDC Brampton" [items]="['HDC Brampton']" stylingMode="filled"
                                        [readOnly]="isReadOnly" placeholder="Select Warehouse">
                                    </dx-select-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Trailer Type:*</label>
                                    <dx-select-box [(value)]="emptyCheckIn.trailerType" [items]="trailerTypeOptions"
                                        valueExpr="value" displayExpr="text" stylingMode="filled"
                                        placeholder="Select Trailer Type" [readOnly]="isReadOnly">
                                    </dx-select-box>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Trailer Number:*</label>
                                    <dx-text-box stylingMode="filled" [(value)]="emptyCheckIn.trailerNumber" maxLength="100"
                                        placeholder="Enter trailer number" [readOnly]="isReadOnly">
                                    </dx-text-box>
                                </div>
                            </div>
                            @if (this.number) {
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label">Shipment #:</label>
                                        <dx-tag-box [(value)]="emptyCheckIn.shipments"
                                            [dataSource]="shipmentDataSource"
                                            displayExpr="logisticalGroup" valueExpr="logisticalGroup"
                                            [searchEnabled]="true" [showClearButton]="true" stylingMode="filled"
                                            placeholder="Shipment #"
                                            [readOnly]="isReadOnly || emptyCheckIn.status !== EmptyCheckInStatus.EmptyRequired">
                                        </dx-tag-box>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Employee (assign to load):</label>
                                        <dx-select-box [(value)]="emptyCheckIn.employeeId"
                                            [dataSource]="employeeDataSource"
                                            displayExpr="name" valueExpr="id"
                                            [searchEnabled]="true" [showClearButton]="true" stylingMode="filled"
                                            placeholder="Select..."
                                            [readOnly]="isReadOnly || emptyCheckIn.status !== EmptyCheckInStatus.EmptyRequired">
                                        </dx-select-box>
                                    </div>
                                </div>
                            }
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Original Location:*</label>
                                    <dx-select-box
                                        stylingMode='filled'
                                        valueExpr="value"
                                        displayExpr="text"
                                        [items]="shuntLocationOptions"
                                        [(value)]="emptyCheckIn.location"
                                        (onValueChanged)="onLocationTypeChanged($event)"
                                        [readOnly]="isReadOnly || !!this.number"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                @if(emptyCheckIn.location !== undefined &&
                                    emptyCheckIn.location !== shuntLocation.Office)
                                {
                                    <div class="col-md-6">
                                        <label class="form-label">Original Location #:*</label>
                                        <dx-select-box
                                            stylingMode="filled"
                                            valueExpr="id"
                                            displayExpr="number"
                                            [value]="emptyCheckIn.shuntLocationId"
                                            (onValueChanged)="onValueChanged($event.value)"
                                            [dataSource]="shuntLocationDataSource"
                                            placeholder="Select a location"
                                            [searchEnabled]="true"
                                            [readOnly]="isReadOnly || !!this.number"
                                        >
                                            <dx-validator>
                                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <app-notes
                        [entityId]="number"
                        [noteType]="NoteType.EmptyCheckIn"
                        [canCreate]="true"
                        (noteSaved)="onNoteSaved()"
                        (noteCanceled)="onNoteCanceled()"
                    ></app-notes>
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>

    <shunt-move-form [(visible)]="isAddShuntMovePopupOpened" (onSave)="onShuntMovePopupSaveClick()" [titlePrefix]="'Add'"></shunt-move-form>
</div>
